import { useEffect } from "react";
import ArticleVideo from "../ArticleVideo";

function extractYoutubeId(input) {
	if (!input) return "";

	if (/^[a-zA-Z0-9_-]{11}$/.test(input)) {
		return input;
	}

	try {
		const parsedUrl = new URL(input);

		if (parsedUrl.hostname.includes("youtu.be")) {
			const id = parsedUrl.pathname.replace("/", "").trim();
			return /^[a-zA-Z0-9_-]{11}$/.test(id) ? id : "";
		}

		const v = parsedUrl.searchParams.get("v");

		if (v && /^[a-zA-Z0-9_-]{11}$/.test(v)) {
			return v;
		}

		const shortsMatch = parsedUrl.pathname.match(/\/shorts\/([a-zA-Z0-9_-]{11})/);
		if (shortsMatch?.[1]) {
			return shortsMatch[1];
		}

		const liveMatch = parsedUrl.pathname.match(/\/live\/([a-zA-Z0-9_-]{11})/);
		if (liveMatch?.[1]) {
			return liveMatch[1];
		}

		const embedMatch = parsedUrl.pathname.match(/\/embed\/([a-zA-Z0-9_-]{11})/);
		if (embedMatch?.[1]) {
			return embedMatch[1];
		}
	} catch {}

	return "";
}

function getYoutubeWatchUrl(src) {
	const videoId = extractYoutubeId(src);

	if (!videoId) {
		return src || "";
	}

	return `https://www.youtube.com/watch?v=${videoId}`;
}

function getCookie(name) {
	var matches = document.cookie.match(
		new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"),
	);

	return matches ? decodeURIComponent(matches[1]) : undefined;
}

function YouTube(props) {
	if (props.article) {
		return (
			<ArticleVideo
				src={getYoutubeWatchUrl(props.src)}
				title={props.title}
				thumbnail={props.thumbnail}
				thumbnailUrl={props.thumbnailUrl}
				poster={props.poster}
			/>
		);
	}

	useEffect(() => {
		var cookieValue = getCookie("cookieyes-consent");

		if (cookieValue) {
			var consents = cookieValue.split(",");
			var analyticsConsent = consents
				.find(function (c) {
					return c.startsWith("analytics");
				})
				?.split(":")[1];

			var advertisementConsent = consents
				.find(function (c) {
					return c.startsWith("advertisement");
				})
				?.split(":")[1];

			if (analyticsConsent === "no" || advertisementConsent === "no") {
				var containers = document.querySelectorAll(".youtube-cookies");

				if (containers.length > 0) {
					for (var i = 0; i < containers.length; i++) {
						updateContent(containers[i]);
					}
				}
			}
		}

		function updateContent(container) {
			container.textContent = "";

			var section = document.createElement("section");
			section.setAttribute("aria-live", "assertive");
			section.setAttribute("class", "cookie-alert");
			section.setAttribute("role", "alert");

			var p1 = document.createElement("p");
			p1.textContent =
				"Aby zobaczyć film, konieczna jest zgoda na używanie plików cookie analitycznych oraz reklamowych.";
			section.appendChild(p1);

			var p2 = document.createElement("p");
			p2.textContent =
				"Jeżeli wyrażasz zgodę, prosimy o zaakceptowanie plików cookie, a następnie odświeżenie strony.";
			section.appendChild(p2);

			var button = document.createElement("button");
			button.setAttribute("aria-label", "Zarządzaj zgodami na pliki cookie");
			button.setAttribute("class", "pd-btn pd-btn--primary");
			button.onclick = triggerConsentManager;
			button.textContent = "Zarządzaj zgodami na pliki cookie";
			section.appendChild(button);

			container.appendChild(section);
		}

		function triggerConsentManager() {
			var consentButton = document.querySelector(".cky-btn-revisit");

			if (consentButton) {
				consentButton.click();
			} else {
				alert("Przycisk zarządzania zgodami nie jest dostępny.");
			}
		}
	}, []);

	const videoId = extractYoutubeId(props.src);

	const videoSrc =
		`https://www.youtube.com/embed/${videoId}` +
		"?enablejsapi=1&modestbranding=1&controls=1&disablekb=1&rel=0&showinfo=0&fs=1&playsinline=1&color=white" +
		(props.autoplay ? "&autoplay=1" : "");

	const allowOptions =
		"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";

	const containerClass = `youtube-full-width youtube-cookies ${
		props.modal ? "youtube-modal" : ""
	}`;

	if (!videoId) {
		return <div className="image-placeholder">Nieprawidłowy link YouTube</div>;
	}

	return (
		<div className={containerClass}>
			<iframe
				width="560"
				height="315"
				title={props.title || "YouTube video"}
				frameBorder="0"
				allow={allowOptions}
				allowFullScreen
				src={videoSrc}
				className="youtube-full-width__video"
			></iframe>
		</div>
	);
}

export default YouTube;
